import { Component, Input, ViewChild } from '@angular/core';
import { ChangelogInterimsAqReport } from '../../interfaces/changelog-interims-aq-report';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'avs-changelog-interims-aq-report',
  standalone: false,
  templateUrl: './changelog-interims-aq-report.component.html',
  styleUrl: './changelog-interims-aq-report.component.css'
})
export class ChangelogInterimsAqReportComponent {
  displayedColumns: string[] = ['metaName', 'deviceName', 'deviceId', 'time', 'ledStellcode', 'blinkerIndicator', 'brightness', 'batteryVoltage', 'onlineStatus', 'duration'];
  /* 'batteryVoltage', 'blinkerIndicator', 'brightness', 'deciderName', 'deciderTimestamp', 'decision', 'deviceName', 'duration', 'metaName', 'stellcode', 'timestampFrom', 'timestampTo' */
  dataSource?: MatTableDataSource<ChangelogInterimsAqReport>;

  @Input() interimsAqReports: ChangelogInterimsAqReport[] = [];


  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.interimsAqReports);
    if (this.paginator)
      this.dataSource!.paginator = this.paginator;
    if (this.sort)
      this.dataSource!.sort = this.sort;
  }

}
